import { render, staticRenderFns } from "./EcommerceClientOnboarded.vue?vue&type=template&id=5cfd09d3&scoped=true&"
import script from "./EcommerceClientOnboarded.vue?vue&type=script&lang=js&"
export * from "./EcommerceClientOnboarded.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceClientOnboarded.vue?vue&type=style&index=0&id=5cfd09d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd09d3",
  null
  
)

export default component.exports